import { render, staticRenderFns } from "./Form20Layout.vue?vue&type=template&id=f9dd3082&scoped=true"
import script from "./Form20Layout.vue?vue&type=script&lang=ts"
export * from "./Form20Layout.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=f9dd3082&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9dd3082",
  null
  
)

export default component.exports